import { Z_INDEXES } from '@traba/theme'
import styled from 'styled-components'

const TOUR_OVERLAY_Z = Z_INDEXES.MODAL

interface SpotlightDivProps {
  $top: number
  $left: number
  $width: number
  $height: number
  $opacity: number
  $borderRadius: number
}

/** Fullscreen click-catcher behind the spotlight */
export const OverlayBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${TOUR_OVERLAY_Z};
`

/** Spotlight div: transparent hole with a huge box-shadow to dim everything else */
export const SpotlightDiv = styled.div<SpotlightDivProps>`
  position: fixed;
  z-index: ${TOUR_OVERLAY_Z + 1};
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, ${({ $opacity }) => $opacity});
  pointer-events: none;
  transition:
    top 200ms ease,
    left 200ms ease,
    width 200ms ease,
    height 200ms ease;
`

interface GuidedTourOverlayProps {
  targetRect: DOMRect
  overlayOpacity: number
  spotlightPadding: number
  allowInteraction: boolean
  cursor?: string
}

export function GuidedTourOverlay({
  targetRect,
  overlayOpacity,
  spotlightPadding,
  allowInteraction,
  cursor,
}: GuidedTourOverlayProps) {
  const top = targetRect.top - spotlightPadding
  const left = targetRect.left - spotlightPadding
  const width = targetRect.width + spotlightPadding * 2
  const height = targetRect.height + spotlightPadding * 2

  // When allowInteraction is true, use clip-path to cut a hole in the
  // click-blocking backdrop so only the spotlight area is interactive,
  // while the dimmed surroundings still block clicks.
  const backdropStyle: React.CSSProperties = {
    ...(cursor ? { cursor } : {}),
    ...(allowInteraction
      ? {
          clipPath: `polygon(evenodd,
            0% 0%, 0% 100%, 100% 100%, 100% 0%,
            ${left}px ${top}px,
            ${left}px ${top + height}px,
            ${left + width}px ${top + height}px,
            ${left + width}px ${top}px,
            ${left}px ${top}px
          )`,
        }
      : {}),
  }

  return (
    <>
      <OverlayBackdrop
        style={
          Object.keys(backdropStyle).length > 0 ? backdropStyle : undefined
        }
      />
      <SpotlightDiv
        $top={top}
        $left={left}
        $width={width}
        $height={height}
        $opacity={overlayOpacity}
        $borderRadius={8}
      />
    </>
  )
}
